module.exports = __webpack_public_path__ + "img/img2.4a3b713a.png";